export default __webpack_public_path__ + "static/media/BB_33.52fd25bb.png";